import { HERO_FALLBACK_IMAGES } from '../constants';
import { type DualPropositionHeroContent } from '../types';

type TranslateHome = (key: string) => string;

export function getFallbackHeroContent(
  t: TranslateHome
): DualPropositionHeroContent {
  const subtext = t('DualProposition.Description');

  return {
    buy: {
      title: t('DualProposition.Buy.Title.Default'),
      subtext,
      mobileImageUrl: HERO_FALLBACK_IMAGES.buy.mobile,
      desktopImageUrl: HERO_FALLBACK_IMAGES.buy.desktop,
      imageAltText: HERO_FALLBACK_IMAGES.buy.alt,
    },
    sell: {
      title: t('DualProposition.Sell.Title.Default'),
      subtext,
      mobileImageUrl: HERO_FALLBACK_IMAGES.sell.mobile,
      desktopImageUrl: HERO_FALLBACK_IMAGES.sell.desktop,
      imageAltText: HERO_FALLBACK_IMAGES.sell.alt,
    },
  };
}
